import React, { memo } from "react";
import { Box, BoxProps } from "@mui/material";

const CustomBox = memo((props: BoxProps) => {
  return <Box {...props} />;
});

export { CustomBox };
